export default __webpack_public_path__ + "static/media/ripIcon.74992bc0.png";